import styled from 'styled-components';
import { Layout } from 'antd';
import { media } from '../../../../styles/themes/constants';

export const Sider = styled.menu`
  width: 30vh;
  margin-top: 15vh;
`;

export const LayoutMain = styled(Layout)`
  @media only screen and ${media.md} {
    margin-left: 80px;
  }

  @media only screen and ${media.xl} {
    margin-left: unset;
  }
`;
